











import Vue from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Helpers from './helpers';

export default Vue.extend({
  name: 'App',
  components: {
    Header, Footer
  }
});

// Preload heavy images or gifs that are used in other pages
Helpers.preloadImages([
  "img/projects/MultiRPG.gif",
  "img/projects/UE_LevelSet.gif",
  "https://raw.githubusercontent.com/AntonioPriego/UGR_InformaticaGrafica/main/Capturas/2_2.png",
  "img/projects/FallGuysWannaBe.gif",
  "img/projects/DungeonPuzzle.gif",
  "img/projects/MechaBola.gif",
  "img/projects/Furbolin.gif",
  "https://raw.githubusercontent.com/AntonioPriego/SmartPen/main/Memory/capturas/SmartPenMP.png",
  "img/projects/civitas.png",
  "img/projects/sobel.jpg",
  "img/projects/TiradApp/Preview.png"
]);

